import axios from 'axios'
import {asNumber, asResponse, qs} from '../util'
import {mutate} from 'swr'

export const RESPONSE_SWR_KEY = ({responseId}) => [
  '/bff/responses/${responseId}',
  responseId
]

export const getResponse = async (url, responseId) => {
  if (!responseId) {
    return {
      response: undefined
    }
  }
  const resp = await asResponse(axios.get(url.replace('${responseId}', responseId)))
  return {
    response: resp.data
  }
}

export const mutateResponse = async function () {
  let args = Array.from(arguments)
  const responseId = args[args.length - 1]
  const key = RESPONSE_SWR_KEY({responseId})
  args = [key, ...args]
  return mutate.apply(this, args)
}

export const upsertResponse = async (response) => {
  const verb = response.id ? 'put' : 'post'
  const path = response.id ? `/bff/responses/${response.id}` : `/bff/responses`
  const resp = await asResponse(axios[verb](path, {...response, ...{weight: asNumber(response.weight)}}))
  return resp.data
}

export const removeResponse = async (responseId, skipConflictCheck) => {
  return axios.delete(`/bff/responses/${responseId}${qs({skipConflictCheck})}`)
}

export const cloneResponse = async (responseId) => {
  const resp = await asResponse(axios.post(`/bff/responses/clone`, {id: responseId}))
  return resp.data
}

export const copyResponseTo = async (responseId, serviceId, versionId, environmentId, resourceId) => {
  const resp = await asResponse(axios.post(`/bff/responses/copy-to`, {
    id: responseId,
    serviceId,
    versionId,
    environmentId,
    resourceId
  }))
  return resp.data
}

export const toggleResponse = async (responseId) => {
  await asResponse(axios.post(`/bff/responses/toggle`, {responseId}))
}

export const saveResponseScript = async (responseId, script) => {
  const resp = await asResponse(axios.post(`/bff/responses/save-script`, {responseId, script}))
  return resp.data
}
